import Layout from "../components/layout/Layout";
import Breadcrumb from "../components/layout/Breadcrumb";
import React from "react";
import MissieVisie from "../components/over-ons/MissieVisie";
import FunAtWork from "../components/over-ons/FunAtWork";
import OverOns from "../components/shared/OverOns";
import StayConnected from "../components/over-ons/StayConnected";
import Head from "next/head";

const PageOverOns: React.FC = () => {
    return (
        <>
            <Head>
                <link rel="manifest" href="/manifest.webmanifest"/>
                <link rel="apple-touch-icon" href="/assets/imgs/app/apple-touch-icon.png"/>
                <link
                    rel="apple-touch-icon"
                    sizes="48x48"
                    href="/assets/imgs/app/apple-touch-icon-48x48.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="57x57"
                    href="/assets/imgs/app/apple-touch-icon-57x57.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="72x72"
                    href="/assets/imgs/app/apple-touch-icon-72x72.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="76x76"
                    href="/assets/imgs/app/apple-touch-icon-76x76.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="114x114"
                    href="/assets/imgs/app/apple-touch-icon-114x114.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="120x120"
                    href="/assets/imgs/app/apple-touch-icon-120x120.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="144x144"
                    href="/assets/imgs/app/apple-touch-icon-144x144.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="152x152"
                    href="/assets/imgs/app/apple-touch-icon-152x152.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="180x180"
                    href="/assets/imgs/app/apple-touch-icon-180x180.png"
                />
                <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5"/>
                <meta charSet="utf-8"/>
                <meta name="msapplication-TileColor" content="#ffffff"/>
                <meta name="msapplication-TileImage" content="/assets/imgs/ms-icon-144x144.png"/>
                <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
                <meta name="viewport" content="width=device-width, initial-scale=1"/>
                <meta name="author" content="Cohesian"/>
                <meta name="theme-color" content="#ffffff"/>
                <meta name="description"
                      content="Bij Cohesian staan persoonlijke ontwikkeling en fun centraal. Wij geloven erin dat de verbondenheid binnen ons team en onze sterke connectie met de maatschappij, ons voortstuwen om excellentie te benaderen en voor technologische innovatie te zorgen."/>
                <meta name="keywords"
                      content="Engineering, Consultancy/consulting, Entrepreneurship, Entrepreneur, Ondernemer, Ondernemerschap, Technische profielen, Ingenieur, Innovatie, Fun, Connectie, Connection, Excellence, Excellentie, Ingenieursbureau, Partner, Persoonlijke ontwikkeling, Projectsourcing, Recruitment, Rekrutering, Training, Begeleiding, advies, Vacature, Jobs, Werk, Functie, Fun factor, Koffie, Netwerken, Maakindustrie, Automotive, Farmaceutica, Cosmetica"/>
                <meta property="og:title" content="Cohesian Engineering"/>
                <meta property="og:description"
                      content="Visit our website for updates and information about Cohesian Engineering."/>
                <meta property="og:url" content="https://www.cohesian.be/"/>
                <title>Cohesian | Over Ons</title>
            </Head>
            <Layout>
                <Breadcrumb title="Over ons" url="/OverOns"/>
                <MissieVisie/>
                <FunAtWork/>
                <OverOns withButton={false}/>
                <StayConnected/>
            </Layout>
        </>
    );
};

export default PageOverOns;
